import { createAction } from "@reduxjs/toolkit";
export const TAP_ACTIVE_CALL = "TAP_ACTIVE_CALL";
export const tapActiveCallAction = createAction(TAP_ACTIVE_CALL)